import { render, staticRenderFns } from "./MoveFleetItemsBetweenFleets.vue?vue&type=template&id=5ffb936b&scoped=true"
import script from "./MoveFleetItemsBetweenFleets.vue?vue&type=script&lang=js"
export * from "./MoveFleetItemsBetweenFleets.vue?vue&type=script&lang=js"
import style0 from "./MoveFleetItemsBetweenFleets.vue?vue&type=style&index=0&id=5ffb936b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffb936b",
  null
  
)

export default component.exports